// 顧客の保存（PUT /cmp/floor/clients/:uid）で、サーバが次回課金日の確認を求めたときの共通の流れ。Edit.vue・Join.vue が使う。
// サーバ（Clients::UpdateProfileCommand）は二重請求になりうる日（G-4・G-5）を確認なしでは保存せず、code と confirmation を返す。
// 文言では判定しない。再送は最初の内容のまま確認の値（ダイジェスト）だけ足す。内容が変わっていれば、サーバが最新の内容でまた確認を求める
export const BILLING_CONFIRMATION_CODE = 'next_subsc_date_confirmation_required'
export const BILLING_CONFIRMATION_PARAM = 'billing_confirmation_digest'
const STALE_NOTE = '確認のあとに内容が変わりました。最新の内容を確認してください。'

export const billingConfirmationOf = res => {
  const data = res && res.data
  if (!data || data.code !== BILLING_CONFIRMATION_CODE) return null
  return data.confirmation || null
}

// send(formData) で送り、ask(confirmation) が true のときだけ確認の値を付けて再送する。
// 戻り値の res は最後の応答。キャンセルは res: null, canceled: true（呼び出し元は編集の内容をそのまま残す）
export const saveWithBillingConfirmation = async ({ formData, send, ask }) => {
  let res = await send(formData)
  let confirmation = billingConfirmationOf(res)
  while (confirmation) {
    if ((await ask(confirmation)) !== true) return { res: null, canceled: true }
    formData.set(BILLING_CONFIRMATION_PARAM, confirmation.digest)
    res = await send(formData)
    confirmation = billingConfirmationOf(res)
  }
  return { res, canceled: false }
}

// 確認のダイアログ。msgBoxConfirm は ok=true / キャンセルボタン=false / ×・背景・Esc=null を返す
export const askBillingConfirmation = (vm, confirmation) => {
  const h = vm.$createElement
  const lines = [
    ...(confirmation.stale ? [STALE_NOTE] : []),
    ...confirmation.warnings.map(warning => warning.message)
  ]
  return vm.$bvModal.msgBoxConfirm(h('div', {}, lines.map(line => h('p', { class: 'mb-2' }, line))), {
    title: '次回課金日の確認',
    okTitle: '理解して保存する',
    cancelTitle: '保存しない',
    okVariant: 'warning',
    cancelVariant: 'secondary',
    centered: true
  })
}
